export default __webpack_public_path__ + "static/media/ImageIconWhite.c0fe1fb2.svg";